import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import UndoIcon from "@mui/icons-material/Undo";
import Modal from "@mui/material/Modal";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import api from "../../api/api";
import { red, blue, green, purple } from "@mui/material/colors";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  TableHead,
  TableCell,
  Table,
  TableRow,
  TableBody,
  Paper,
  CardContent,
  Typography,
  CircularProgress,
} from "@mui/material";

import {
  getFaqSectionThunk,
  createFaqSectionThunk,
  updateFaqSectionThunk,
  deleteFaqSectionThunk,
} from "./FaqSectionThunk";
import { language_change, usertype_change } from "./FaqSectionSlice";

const FaqSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [recordId, setRecordId] = useState("");
  const [selectedSkillsetId, setSelectedSkillsetId] = useState("");
  const [selectedSkillsetName, setSelectedSkillsetName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, _id, sectionId, sectionName, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setRecordId(_id);
    setSelectedSkillsetId(sectionId);
    setSelectedSkillsetName(sectionName);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };
  // ---------------------------------------------

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/faq");
  };
  // ------------------------------------------------------------

  // --------- options for dropdowns ---------
  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
  ];
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];
  const validity_select_option_list = [
    { value: "limited", text: "Limited" },
    { value: "unlimited", text: "Unlimited" },
  ];
  // ------------ dropdowns on change ----------------
  const language_select_onchange = (event) => {
    dispatch(language_change(event.target.value));
  };
  const usertype_select_onchange = (event) => {
    dispatch(usertype_change(event.target.value));
  };

  const { loading, usertype, language, section, sectionId, sectionName } =
    useSelector((state) => state.FaqSectionSlice);
  console.log(
    "useSelector....",
    usertype,
    language,
    section,
    sectionId,
    sectionName
  );

  useEffect(() => {
    const load_data = () => {
      const params = { usertype };
      dispatch(getFaqSectionThunk(params));
    };
    load_data();
  }, [dispatch, usertype]);

  // -----------------------------------------------

  // For State Declaration
  const [show, setShow] = useState(false);

  //On Modal close and open

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showUpdate, setShowUpdate] = useState(false);
  const [changeSectionName, setChangeSectionName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [updateData, setUpdateData] = useState({
    sectionId: sectionId,
    sectionName: "",
    usertype,
    language,
    quizData: [],
  });

  const handleChangeSectionName = (event) => {
    setChangeSectionName(event.target.value);
  };

  // ----------- create, update delete button click ----------

  // const handleSave = () => {
  //   const dataa = {
  //     sectionId: new Date().getTime(),
  //     sectionName: changeSectionName,
  //     language,
  //     usertype,
  //   };
  //   setShow(false);
  //   setIsLoading(true);

  //   dispatch(createFaqSectionThunk(dataa))
  //     .then((response) => {
  //       console.log("createFaqSectionThunk", response);
  //       toast.success("Changes made successfully");
  //       const params = { usertype };
  //       dispatch(getFaqSectionThunk(params)).catch((getFaqError) => {
  //         console.error("Error in getFaqSectionThunk:", getFaqError);
  //         alert("Something went wrong while fetching data. Please try again.");
  //       });
  //     })
  //     .catch((error) => {
  //       console.error("Error:", error);
  //       alert("Something went wrong. Please try again.");
  //     });
  // };
  const handleSave = () => {
    const dataa = {
      sectionId: new Date().getTime(),
      sectionName: changeSectionName,
      language,
      usertype,
    };
    setShow(false);
    setIsLoading(true);

    dispatch(createFaqSectionThunk(dataa))
      .then((response) => {
        console.log("createFaqSectionThunk", response);
        toast.success("Changes made successfully", {
          style: {
            backgroundColor: "green",
            color: "white",
            borderRadius: "30px",
          },
        });
        const params = { usertype };
        dispatch(getFaqSectionThunk(params))
          .catch((getFaqError) => {
            console.error("Error in getFaqSectionThunk:", getFaqError);
            if (getFaqError.response && getFaqError.response.status === 500) {
              toast.error("Internal Server Error. Please try again later.");
            } else if (
              getFaqError.response &&
              getFaqError.response.status === 504
            ) {
              toast.error("Gateway Timeout. Please try again later.");
            } else {
              toast.error(
                "Something went wrong while fetching data. Please try again."
              );
            }
          })
          .finally(() => {
            setIsLoading(false);
          });
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
        if (error.response) {
          if (error.response.status === 500) {
            toast.error("Internal Server Error. Please try again later.");
          } else if (error.response.status === 504) {
            toast.error("Gateway Timeout. Please try again later.");
          } else {
            toast.error("Something went wrong. Please try again.");
          }
        } else {
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  const [updateExtra, setUpdateExtra] = useState([]);
  const handleShowUpdate = (eachskill) => {
    setUpdateExtra(eachskill);
    setUpdateData({
      sectionId: eachskill?.sectionId,
      sectionName: eachskill?.sectionName,
      usertype,
      language,
      quizData: [],
    });
    setShowUpdate(true);
  };

  const handleUpdateChanges = () => {
    dispatch(updateFaqSectionThunk(updateData))
      .then((res) => {
        const params = { usertype };
        dispatch(getFaqSectionThunk(params));
      })
      .catch((error) => {
        console.error("Error:", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
    setShowUpdate(false);
  };
  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  const deleteEachSection = (sections) => {
    console.log("sections", sections);
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const params = { sectionId: sections?.sectionId };
        dispatch(deleteFaqSectionThunk(params))
          .then((response) => {
            const params = { usertype };
            dispatch(getFaqSectionThunk(params));
            toast.success("Changes made successfully");
          })
          .catch((error) => {
            console.error("Error:", error);
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
          });
      }
    });
  };

  return (
    <>
      <div>
        <MuiHeader header="FAQ Section" />
        <div style={{ display: "flex" }}>
          <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
            <InputLabel id="demo-select-small">Language</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={language}
              label="Language"
              onChange={language_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {language_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
            <InputLabel id="demo-select-small">Usertype</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={usertype}
              label="Language"
              onChange={usertype_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {usertype_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <Button
          onClick={navigate_to}
          variant="outlined"
          sx={{
            minWidth: 80,
            alignItem: "right",
            backgroundColor: "blue",
            color: "white",
            "&:hover": {
              backgroundColor: "blue", // Maintain the color even on hover
            },
            marginLeft: "auto",
          }}
        >
          <UndoIcon style={{ color: "orange" }}></UndoIcon>
          Back
        </Button>
      </div>

      {/* Show List */}
      <div>
        <div>
          <Button
            onClick={handleShow}
            variant="contained"
            sx={{ marginTop: 3, float: "left" }}
            // disabled={disable_content_button}
          >
            create new section
            {/* <AddIcon /> */}
          </Button>
          <br />
          <br />
          <br />

          <Modal
            open={show}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box sx={style}>
              <br />
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
                style={{ maxHeight: "200px", overflowY: "auto" }}
              >
                <Grid container spacing={2} style={{ padding: "16px" }}>
                  <Grid item xs={12}>
                    <TextField
                      id="outlined-basic"
                      label="Section"
                      variant="outlined"
                      fullWidth
                      onChange={handleChangeSectionName}
                      inputProps={{
                        style: { maxHeight: "180px", overflowY: "auto" },
                      }}
                    />
                  </Grid>
                </Grid>
              </FormControl>
              <Button
                variant="outlined"
                style={{ marginLeft: 12 }}
                onClick={handleClose}
              >
                Close
              </Button>
              <Button variant="contained" onClick={handleSave}>
                Save
              </Button>
            </Box>
          </Modal>
        </div>
        <br />

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "50px",
            }}
          >
            <CircularProgress />
          </div>
        ) : section && section?.length > 0 ? (
          <Grid container spacing={3}>
            {section?.map((eachSkill, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card>
                  <CardContent>
                    <Typography variant="body1" style={{ fontWeight: "bold" }}>
                      {index + 1}. {eachSkill?.sectionName}
                    </Typography>
                    <div style={{ marginTop: "20px" }}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Button
                            onClick={() => handleShowUpdate(eachSkill)}
                            fullWidth
                            variant="contained"
                            color="primary"
                          >
                            Edit
                          </Button>
                        </Grid>
                        <Grid item xs={6}>
                          <Button
                            onClick={() => deleteEachSection(eachSkill)}
                            fullWidth
                            variant="contained"
                            color="error"
                          >
                            Delete
                          </Button>
                        </Grid>
                      </Grid>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          ""
          // <div style={{ textAlign: "center", marginTop: "20px" }}>
          //   <Typography variant="body1">No sections available</Typography>
          // </div>
        )}

        <Modal
          open={showUpdate}
          onClose={handleCloseUpdate}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box sx={style}>
            <FormControl
              fullWidth
              size="small"
              variant="outlined"
              style={{ maxHeight: "200px", overflowY: "auto" }}
            >
              <Grid container spacing={2} style={{ padding: "16px" }}>
                <Grid item xs={12}>
                  <TextField
                    id="outlined-basic"
                    label="Section"
                    variant="outlined"
                    value={updateData?.sectionName}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        sectionName: e.target.value,
                      })
                    }
                    inputProps={{
                      style: { maxHeight: "180px", overflowY: "auto" },
                    }}
                  />
                </Grid>
              </Grid>
            </FormControl>

            <Button
              variant="outlined"
              style={{ marginLeft: 12 }}
              onClick={handleCloseUpdate}
            >
              Close
            </Button>
            <Button variant="contained" onClick={handleUpdateChanges}>
              Update
            </Button>
          </Box>
        </Modal>
      </div>
      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default FaqSection;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
